import {
  getAdoptionProcessIcon,
  getChatIcon,
  getMarkerIcon,
  getSaveLifeIcon,
  getTTIcon,
  getTTLogo,
  getVerifiedSheltersIcon,
} from "../services/icons";

const ipataImg = new URL("../assets/images/ipata.png", import.meta.url);
const pmsImg = new URL("../assets/images/pms.png", import.meta.url);
const smsImg = new URL("../assets/images/sms.svg", import.meta.url);

const promoItems = [
  {
    title: "100% Verified Shelters",
    icon: () => getVerifiedSheltersIcon(),
  },

  {
    title: "Reliable Adoption Process",
    icon: () => getAdoptionProcessIcon(),
  },
  {
    title: "Save a Life!",
    icon: () => getSaveLifeIcon(),
  },
];

export default function Footer() {
  return (
    <div id="footer">
      <div className="border-b-[1px] border-t-[1px] border-[#E8E8E8]">
        <div className="container mx-auto">
          <div className="mx-auto grid grid-cols-3 px-5 py-7">
            {promoItems.map((item) => {
              return (
                <div key={item.title} className="flex items-center justify-center gap-2 px-10">
                  {item.icon()}
                  <span className="font-barlowmedium text-theme-grey-11">{item.title}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="border-b-[1px] border-[#E8E8E8]">
        <div className="container mx-auto">
          <div className="mx-auto grid grid-cols-5 gap-4 px-5 py-8">
            <div>
              <div className="mb-3 flex w-[130px] flex-row items-center gap-1">
                {getTTIcon("#121111")}
                {getTTLogo()}
              </div>
              <div>
                <img src={smsImg.href} alt="" />
              </div>
            </div>
            <div>
              <div className="mb-3 font-barlowmedium text-theme-grey-11">
                Adopting with Tailtales
              </div>
              <div className="flex flex-col gap-1 text-[12px] text-[#3D3E3D]">
                <div>How dog adoption with us works</div>
                <div>Our goal</div>
                <div>Tales from our dog shelters</div>
                <div>What our users are saying</div>
                <div>FAQs on Adoption</div>
              </div>
            </div>
            <div>
              <div className="mb-3 font-barlowmedium text-theme-grey-11">For shelters</div>
              <div className="flex flex-col gap-1 text-[12px] text-[#3D3E3D]">
                <div>How to join Tailtales</div>
                <div>Financial support</div>
                <div>Increased visability</div>
                <div>Marketing assistance</div>
                <div>Community engagement</div>
              </div>
            </div>
            <div>
              <div className="mb-3 font-barlowmedium text-theme-grey-11">Customer service</div>
              <div className="flex flex-col gap-1 text-[12px] text-[#3D3E3D]">
                <div>Contact us</div>
                <div>In media</div>
                <div>Work with us!</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-b-[1px] border-[#E8E8E8]">
        <div className="container mx-auto">
          <div className="mx-auto grid grid-cols-5 gap-4 px-5 py-6">
            <div>
              <div className="mb-3 font-barlowmedium text-theme-grey-11">We ship with</div>
              <div>
                <img src={ipataImg.href} alt="" />
                <div className="mt-1 text-[12px] text-[#555555]">
                  <span className="underline">IPATA</span> registered pet shipping companies.
                </div>
              </div>
            </div>
            <div>
              <div className="mb-3 font-barlowmedium text-theme-grey-11">Payment methods</div>
              <div>
                <img src={pmsImg.href} alt="" />
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
      <footer className="flex flex-col items-center justify-center gap-4 bg-[#0C0202] py-6 text-[14px] text-[#C0C0C0]">
        <div className="container mx-auto px-5">
          <div className="flex w-full items-center justify-between">
            <div>
              <span className="flex items-center gap-2">© 2025 Tailtales AB</span>
            </div>
            <div>
              <span className="flex items-center gap-2">
                {getMarkerIcon()}
                Sweden <span className="text-[14px] leading-none">|</span> inger@gmail.com
              </span>
            </div>
            <div>{getChatIcon("#B2B1B1", "30px")}</div>
          </div>
        </div>
      </footer>
    </div>
  );
}
